import { UIComponent } from "../../components";
import { unicodeCaseInsensitiveSearch } from "../../utils/unicodeCaseInsensitiveSearch";

export class ModalAITemplates extends UIComponent {
    init() {
        this.dataJSON = this.dataJson("json-content");

        this.hasHoverSupport = window.matchMedia("(hover: hover)").matches;

        this.on("click", this.handleClick.bind(this));
        this.templateViewer.onBack(this.hideContentViewer.bind(this));
        this.templateCreate.onBack(this.hideCreateTemplate.bind(this));

        this.accordions.onActive(this.scrollToCategory.bind(this));
        this.search.on("input", this.handleInputSearch.bind(this));
        this.selectTpl.on("click", () => this.accordions.show());
        this.accordions?.createTemplateBtn?.on(
            "click",
           this.showCreateTemplate.bind(this)
        );

        this.templateCreate.setParentCallback(this);
    }

    handleClick(ev) {
        const path = ev.composedPath();

        for (let i = 0; i <= path.length; i++) {
            if (path[i] === this.element) break;

            if (
                path[i]?.nodeType === 1 &&
                (path[i].classList.contains("modal-ai-templates__btn-use") ||
                    path[i].classList.contains("promt-btn"))
            ) {
                break;
            }

            if (
                this.hasHoverSupport &&
                path[i]?.nodeType === 1 &&
                path[i].classList.contains("modal-ai-templates__card-wrapper")
            ) {
                const id = path[i].getAttribute("data-item-id");
                this.showContentById(id);
                this.accordions?.changeActiveAccordionItem(id);
                this.selectTpl.hide();
                break;
            }

            if (
                path[i]?.nodeType === 1 &&
                path[i].hasAttribute("data-item-id")
            ) {
                const id = path[i].getAttribute("data-item-id");
                this.showContentById(path[i].getAttribute("data-item-id"));
                this.accordions.changeActiveAccordionItem(id);
                this.selectTpl.hide();
                this.accordions.hide();
                break;
            }

            if (path[i]?.nodeType === 1 && path[i].hasAttribute("href")) {
                break;
            }
        }
    }

    showCreateTemplate() {
        if (this.box) this.box.hide();
        if (this.templateViewer) this.templateViewer.hide();

        if (this.templateCreate) {
            this.templateCreate.show();
        }
    }

    hideCreateTemplate() {
        if (this.box) this.box.show();
        if (this.templateCreate) {
            this.templateCreate.hide();
        }
    }

    hideContentViewer() {
        this.box.show();
        this.templateViewer.hide();
        this.accordions.clearActiveItem();
        this.selectTpl.show();
    }

    showContentById(id) {
        let content;
        let url;
        let editUrl;

        findContent: for (let i = 0; i < this.dataJSON.length; i++) {
            const { templates } = this.dataJSON[i];
            for (let k = 0; k < templates.length; k++) {
                if (templates[k].id == id) {
                    content = templates[k];
                    break findContent;
                }
            }
        }

        for (let i = 0; i < this.categories.length; i++) {
            const category = this.categories[i];
            const item = category.items?.find((item) => {
                const itemId =
                    item.element?.getAttribute("data-item-id") || item.id;
                return itemId == id;
            });
            if (item) {
                url = item.promtBtn?.url;
                editUrl = item.card_content?.edit_url;
                console.log(editUrl);
                break;
            }
        }

        if (!url) {
            const button = document.querySelector(
                `[data-item-id="${id}"] .promt-btn`
            );
            if (button) {
                url =
                    button.getAttribute("data-tbx-var-url") ||
                    button.getAttribute("data-url") ||
                    button.getAttribute("href");
            }
        }

        if (!content?.url && url) content = { ...content, url };
        if (editUrl) content = { ...content, editUrl };

        this.box.hide();
        if (this.templateCreate) this.templateCreate.hide();

        this.templateViewer.show(content);

        this.templateViewer.onEdit(() => {
            this.templateViewer.hide();
            this.templateCreate.showEdit(content);
        });
    }

    scrollToCategory(id) {
        const tbx = this.categories.find((tbx) => tbx.id === id);
        if (!tbx) return;

        tbx.element.scrollIntoView({ behavior: "smooth" });
    }

    handleInputSearch({ target }) {
        const value = target.value;

        const cards = this.changeViewContent(this.categories, value);
        const accordions = this.changeViewContent(this.accordions.items, value);

        Promise.all([cards, accordions]).then((res) => {
            res.includes(false)
                ? this.emptySearch.show()
                : this.emptySearch.hide();
        });
    }

    async changeViewContent(tbxItems, value) {
        const USER_PROMPTS_TITLE = "user_prompts";
        let hasVisibleItems = false;

        for (let i = 0; i < tbxItems.length; i++) {
            const category = tbxItems[i];
            let categoryHasVisibleItems = false;
            const items = category.items ?? [];
            const isUserPromptsEmpty =
                category.title === USER_PROMPTS_TITLE && items.length === 0;

            if (unicodeCaseInsensitiveSearch(category.categoryname, value)) {
                if (!isUserPromptsEmpty) {
                    category.show();
                    category.items?.forEach((tbx) => tbx.show());
                    categoryHasVisibleItems = true;
                } else {
                    category.hide();
                }
            } else {
                for (let k = 0; k < items.length; k++) {
                    const item = items[k];

                    if (unicodeCaseInsensitiveSearch(item.tplName, value)) {
                        item.show();
                        categoryHasVisibleItems = true;
                    } else {
                        item.hide();
                    }
                }

                categoryHasVisibleItems ? category.show() : category.hide();
            }

            if (categoryHasVisibleItems) {
                hasVisibleItems = true;
            }
        }
        return hasVisibleItems;
    }

    handleTemplateSaved(savedData) {
        if (!savedData || !savedData.prompt?.id || !this.dataJSON) return;

        const userPromptsCategory = this.dataJSON.find(
            (cat) => cat.title === "user_prompts"
        );
        if (!userPromptsCategory?.templates) return;

        const existingIndex = userPromptsCategory.templates.findIndex(
            (tpl) => tpl.id === savedData.prompt.id
        );

        const templateData = {
            id: savedData.prompt.id,
            title: savedData.prompt.title || "",
            categoryTitle: "user_prompts",
            name: savedData.prompt.title || "",
            content: savedData.prompt.content || [],
            links: savedData.links || {},
        };

        if (existingIndex !== -1) {
            userPromptsCategory.templates[existingIndex] = templateData;
            this.updateCardInUI(savedData);
        } else {
            userPromptsCategory.templates.push(templateData);
            this.addTemplateToUI(savedData);
            this.accordions.addAccordionItemDirectly(savedData);
        }

        if (this.box) this.box.show();
    }

    addTemplateToUI(templateData) {
    const userPromptsCategory = this.categories[0];
    if (!userPromptsCategory || !userPromptsCategory.grid_template?.element) return;

    const clone = this.prompt_card.element.content.cloneNode(true);
    const cardWrapper = clone.querySelector(".modal-ai-templates__card-wrapper");
    if (!cardWrapper) return;

    cardWrapper.setAttribute("data-item-id", templateData.prompt.id);

    const title = clone.querySelector('[data-tbx-bind="tplName"]');
    if (title) title.textContent = templateData.prompt.title || "";

    const list = clone.querySelector(".modal-ai-templates__card-list");
    if (list) {
        templateData.prompt.content.forEach((item) => {
            const itemHTML = `
                <div class="modal-ai-templates__card-list-item">
                    <div class="modal-ai-templates__card-list-title">${item.title || ""}</div>
                    <div class="modal-ai-templates__card-list-text">${item.text || ""}</div>
                </div>
            `;
            list.querySelector(".modal-ai-templates__card-btns")?.insertAdjacentHTML("beforebegin", itemHTML);
        });
    }

    const viewBtn = clone.querySelector(".modal-ai-templates__btn-show");
    if (viewBtn) viewBtn.setAttribute("data-item-id", templateData.prompt.id);

    const useBtn = clone.querySelector(".promt-btn");
    if (useBtn) {
        if (templateData?.links?.applyTemplate) {
            useBtn.setAttribute("data-tbx-var-url", templateData.links.applyTemplate);
        }
        if (!useBtn.hasAttribute("data-tbx-name")) {
            useBtn.setAttribute("data-tbx-name", "promtBtn");
        }
    }

    userPromptsCategory.grid_template.element.appendChild(clone);
    userPromptsCategory.show();
    this.accordions.items[0].show();
}

    updateCardInUI(templateData) {
        const card = this.categories[0].find(`[data-item-id="${templateData.prompt.id}"]`);
        if (!card) return;
        
        const title = card.querySelector('.title');

        if (title) {
            title.textContent = templateData.prompt.title || "";
            console.log(templateData.prompt.title)
        }

        const list = card.querySelector(".modal-ai-templates__card-list");

        if (list) {
            const oldItems = list.querySelectorAll(".modal-ai-templates__card-list-item");

            oldItems.forEach((item) => item.remove());

            templateData.prompt.content.forEach((item) => {
                const itemHTML = `
                <div class="modal-ai-templates__card-list-item">
                    <div class="modal-ai-templates__card-list-title">${
                        item.title || ""
                    }</div>
                    <div class="modal-ai-templates__card-list-text">${
                        item.text || ""
                    }</div>
                </div>
            `;  list.querySelector(".modal-ai-templates__card-btns")?.insertAdjacentHTML("beforebegin", itemHTML);
            });
        }
    }
}
